import { render, staticRenderFns } from "./GetMessageDetails.vue?vue&type=template&id=288d4548&"
import script from "./GetMessageDetails.vue?vue&type=script&lang=js&"
export * from "./GetMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports